import { useScandiumQuery } from '../../../data-layer/utils';

const useMobileUsage = (options = {}) => {
  return useScandiumQuery('/company/mobile-usage', {
    ...options
  });
};

export default useMobileUsage;
